import {
    QidDatapoint,
    QidModel,
    QidModelSafetyFunction,
    QidModelOption,
    MtDriveFile,
} from "server/models"
import { KeyValue } from "client/utils"

export type QidDatapointList = { [id: number]: QidDatapoint }
export type QidDatapointGroup = {
    parents: {
        model: QidModel
        safetyFunction: QidModelSafetyFunction
        option: QidModelOption
    }
    isNested: boolean // if datapoint has nested datapoints based on failure modes
    datapoints: QidDatapoint[]
    tableView: { // this structure is needed for table
        ids: number[]
        list: QidDatapointList
    }
}

export type QidDatapointActiveCell = {
    datapointId: number
    field: string
}

export type QidDatapointChanges = {
    [datapointId: number]: KeyValue<QidDatapoint>
}

export interface QidDatapointState {
    datapointList: readonly QidDatapointGroup[]
    datapointDelete: QidDatapointGroup

    // edit
    existing: QidDatapoint[]
    new: QidDatapoint[]
    activeCell: QidDatapointActiveCell
    changes: QidDatapointChanges
    deleteExisting: number[]

    referenceList: readonly MtDriveFile[]

    reloadList: boolean
    reloadEdit: boolean
}

export const QID_DATAPOINT_LIST = "QID_DATAPOINT_LIST"
export const QID_DATAPOINT_DELETE = "QID_DATAPOINT_DELETE"

export const QID_DATAPOINT_EXISTING = "QID_DATAPOINT_EXISTING"
export const QID_DATAPOINT_NEW = "QID_DATAPOINT_NEW"
export const QID_DATAPOINT_ACTIVE_CELL = "QID_DATAPOINT_ACTIVE_CELL"
export const QID_DATAPOINT_CHANGES = "QID_DATAPOINT_CHANGES"
export const QID_DATAPOINT_DELETE_EXISTING = "QID_DATAPOINT_DELETE_EXISTING"

export const QID_DATAPOINT_REFERENCE_LIST = "QID_DATAPOINT_REFERENCE_LIST"

export const QID_DATAPOINT_RELOAD_LIST = "QID_DATAPOINT_RELOAD_LIST"
export const QID_DATAPOINT_RELOAD_EDIT = "QID_DATAPOINT_RELOAD_EDIT"
